import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Autocomplete,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { FetchContext } from "../../../contexts";
import { UfficioContext } from '../UfficioContext';

import { Field, Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';


import { ValoreRuoli, Zona } from '../../../../helpers';
import { DateTableRow, UtenteTableRow } from '../../../common';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

const UfficioSchema = Yup.object().shape({
    nome: Yup.string().required("Il nome è un campo obbligatorio"),
    comuneId: Yup.number().required("Il comune è un campo obbligatorio"),
    tipoUfficioId: Yup.number().required("Il tipo è un campo obbligatorio"),
});

export const UfficioDetailsForm = ({
    disabled,
    formRef,
    onActionClick,
    ...props
}) => {

    const {
        state,
        setState,

        isLoadingTipi,
        getTipiAsync,

        isLoadingComuni,
        getComuniAsync,

        isLoadingUffici,
        getUfficiAsync,
    } = useContext(UfficioContext);

    const { user } = useContext(FetchContext);

    const {
        ufficio,
        comuniOptions,
        tipiOptions,
        ufficiOptions,
    } = state;

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    var today = moment();

    const urlParams = new URLSearchParams(window.location.search);
    const nome = urlParams.get('nome');
    const tipoUfficioId = urlParams.get('tipoUfficioId');
    const solaLettura = /^true$/i.test(urlParams.get("solaLettura"));

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        aggiornamento: ufficio?.aggiornamento ?? "",
                        altreSedi: ufficio?.altreSedi ?? "",
                        cap: ufficio?.cap ?? "",
                        codeNew: ufficio?.codeNew ?? "",
                        codiceFiscale: ufficio?.codiceFiscale ?? "",
                        codiceIstatUbicazione: ufficio?.codiceIstatUbicazione ?? "",
                        codiceUfficio: ufficio?.codiceUfficio ?? "",
                        comuneId: ufficio?.comuneId ?? null,
                        id: ufficio?.id ?? null,
                        indirizzo: ufficio?.indirizzo ?? "",
                        infoAggiuntive: ufficio?.infoAggiuntive ?? "",
                        latitudine: ufficio?.latitudine ?? 0,
                        lingueParlate: ufficio?.lingueParlate ?? "",
                        longitudine: ufficio?.longitudine ?? 0,
                        sottotitolo: ufficio?.sottotitolo ?? "",
                        msg: ufficio?.msg ?? "",
                        patrono: ufficio?.patrono ?? "",
                        status: ufficio?.status ?? "",
                        tipoUfficioId: ufficio?.tipoUfficioId ?? tipoUfficioId ?? null,
                        videoConferenza: ufficio?.videoConferenza ?? "",
                        nome: ufficio?.nome ?? nome ?? "",
                        distretto: ufficio?.zona == Zona.Distretto ? true : false,
                        circondario: ufficio?.zona == Zona.Circondario ? true : false,
                        zona: ufficio?.zona ?? null,
                        zonaRiferimentoId: ufficio?.zonaRiferimentoId ?? null,
                        dataAffidabilita: ufficio?.dataAffidabilita ?? null,
                        inizioValidita: ufficio?.inizioValidita ?? moment.utc([today.year(), today.month(), today.date()]),
                        fineValidita: ufficio?.fineValidita ?? (ufficio?.id ? null : moment.utc([today.year(), today.month(), today.date()])),
                        convalidato: ufficio?.convalidato ?? false,
                    }
                }
                enableReinitialize
                validationSchema={UfficioSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justify="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        tipo
                                                    </TableCell>
                                                    <TableCell>
                                                        {
                                                            user.ruolo.valoreRuolo == ValoreRuoli.Redattore ?
                                                                <Typography>
                                                                    {tipiOptions.find(option => option.tipoUfficioId == values.tipoUfficioId)?.label}
                                                                </Typography>
                                                                :
                                                                <Field
                                                                    name="tipoUfficioId"
                                                                    component={Autocomplete}
                                                                    options={tipiOptions}
                                                                    onChange={(e, value) => {
                                                                        setFieldValue('tipoUfficioId', value?.tipoUfficioId)
                                                                    }}
                                                                    value={tipiOptions.find(option => option.tipoUfficioId == values.tipoUfficioId) ?? null}
                                                                    renderInput={(params) => <TextField {...params}
                                                                        label="Scegli..." />}
                                                                    fullWidth
                                                                    disabled={solaLettura}
                                                                />
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        nome
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="nome"
                                                            name="nome"
                                                            value={values.nome}
                                                            onChange={handleChange}
                                                            error={touched.nome && Boolean(errors.nome)}
                                                            helperText={touched.nome && errors.nome}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        sottotitolo (visualizzato in grassetto)
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="sottotitolo"
                                                            name="sottotitolo"
                                                            value={values.sottotitolo}
                                                            onChange={handleChange}
                                                            error={touched.sottotitolo && Boolean(errors.sottotitolo)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        comunicazioni di servizio (visualizzato di colore rosso)
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="msg"
                                                            name="msg"
                                                            value={values.msg}
                                                            onChange={handleChange}
                                                            error={touched.msg && Boolean(errors.msg)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        comune
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="comuneId"
                                                            component={Autocomplete}
                                                            options={comuniOptions}
                                                            onInputChange={(e, value) => getComuniAsync(value?.split(' (')[0], true)}
                                                            onChange={(e, value) => {
                                                                setFieldValue('comuneId', value?.comuneId)
                                                            }}
                                                            value={comuniOptions.find(option => option.comuneId == values.comuneId) ?? null}
                                                            renderInput={(params) => <TextField {...params}
                                                                label="Scegli..."
                                                                error={touched.comuneId && Boolean(errors.comuneId)}
                                                                helperText={touched.comuneId && errors.comuneId} />}
                                                            fullWidth
                                                            disabled={solaLettura}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        cap
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="cap"
                                                            name="cap"
                                                            value={values.cap}
                                                            onChange={handleChange}
                                                            error={touched.cap && Boolean(errors.cap)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                {/* <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        codice fiscale
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="codiceFiscale"
                                                            name="codiceFiscale"
                                                            value={values.codiceFiscale}
                                                            onChange={handleChange}
                                                            error={touched.codiceFiscale && Boolean(errors.codiceFiscale)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow> */}
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        festività locale
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="patrono"
                                                            name="patrono"
                                                            value={values.patrono}
                                                            onChange={handleChange}
                                                            error={touched.patrono && Boolean(errors.patrono)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        indirizzo
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="indirizzo"
                                                            name="indirizzo"
                                                            value={values.indirizzo}
                                                            onChange={handleChange}
                                                            error={touched.indirizzo && Boolean(errors.indirizzo)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        altre sedi
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="altreSedi"
                                                            name="altreSedi"
                                                            value={values.altreSedi}
                                                            onChange={handleChange}
                                                            error={touched.altreSedi && Boolean(errors.altreSedi)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        informazioni
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="infoAggiuntive"
                                                            name="infoAggiuntive"
                                                            value={values.infoAggiuntive}
                                                            onChange={handleChange}
                                                            error={touched.infoAggiuntive && Boolean(errors.infoAggiuntive)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        latitudine
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            type="number"
                                                            id="latitudine"
                                                            name="latitudine"
                                                            value={values.latitudine}
                                                            onChange={handleChange}
                                                            error={touched.latitudine && Boolean(errors.latitudine)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        longitudine
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            type="number"
                                                            id="longitudine"
                                                            name="longitudine"
                                                            value={values.longitudine}
                                                            onChange={handleChange}
                                                            error={touched.longitudine && Boolean(errors.longitudine)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                {
                                                    values.tipoUfficioId == 12 &&
                                                    <TableRow>
                                                        <TableCell style={{ width: "20%" }}>
                                                            distretto
                                                        </TableCell>
                                                        <TableCell>
                                                            <Field
                                                                name="distretto"
                                                                component={Checkbox}
                                                                onChange={e => {
                                                                    setFieldValue('distretto', e.target.checked);
                                                                    if (e.target.checked)
                                                                        setFieldValue('zona', Zona.Distretto);
                                                                    else
                                                                        setFieldValue('zona', null);
                                                                }}
                                                                checked={values.distretto}
                                                                disabled={solaLettura}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    values.tipoUfficioId == 14 &&
                                                    <TableRow>
                                                        <TableCell style={{ width: "20%" }}>
                                                            circondario
                                                        </TableCell>
                                                        <TableCell>
                                                            <Field
                                                                name="circondario"
                                                                component={Checkbox}
                                                                onChange={e => {
                                                                    setFieldValue('circondario', e.target.checked);
                                                                    if (e.target.checked)
                                                                        setFieldValue('zona', Zona.Circondario);
                                                                    else {
                                                                        setFieldValue('zona', null);
                                                                        setFieldValue('zonaRiferimentoId', null);
                                                                    }
                                                                }}
                                                                checked={values.circondario}
                                                                disabled={solaLettura}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    values.tipoUfficioId == 14 &&
                                                    <TableRow>
                                                        <TableCell style={{ width: "20%" }}>
                                                            distretto di riferimento
                                                        </TableCell>
                                                        <TableCell>
                                                            <Field
                                                                name="zonaRiferimentoId"
                                                                onInputChange={(e, value) => getUfficiAsync(value)}
                                                                component={Autocomplete}
                                                                options={ufficiOptions}
                                                                onChange={(e, value) => {
                                                                    setFieldValue('zonaRiferimentoId', value?.ufficioId)
                                                                }}
                                                                value={ufficiOptions.find(option => option.ufficioId == values.zonaRiferimentoId) ?? null}
                                                                disabled={values.zona == null || solaLettura}
                                                                renderInput={(params) => <TextField {...params}
                                                                    label="Scegli..." />}
                                                                fullWidth
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        inizio validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="inizioValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('inizioValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.inizioValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                            disabled={solaLettura}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        fine validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="fineValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('fineValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.fineValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                            disabled={solaLettura}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        codice istat ubicazione
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="codiceIstatUbicazione"
                                                            name="codiceIstatUbicazione"
                                                            value={values.codiceIstatUbicazione}
                                                            onChange={handleChange}
                                                            error={touched.codiceIstatUbicazione && Boolean(errors.codiceIstatUbicazione)}
                                                            inputProps={{ sx: { padding: 1 } }} 
                                                            disabled={solaLettura}/>
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'creato da'} utenteId={ufficio?.creatoDa} />
                                                <DateTableRow label={'data creazione'} stringDate={ufficio?.dataCreazione} />
                                                <UtenteTableRow label={'ultima modifica da'} utenteId={ufficio?.aggiornatoDa} />
                                                <DateTableRow label={'data ultima modifica'} stringDate={ufficio?.dataAggiornamento} />
                                                {/* <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        data di affidabilità dei dati
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="dataAffidabilita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('dataAffidabilita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('dataAffidabilita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.dataAffidabilita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                            disabled={solaLettura}
                                                        />
                                                    </TableCell>
                                                </TableRow> */}
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        convalidato
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="convalidato"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('convalidato', e.target.checked);
                                                            }}
                                                            checked={values.convalidato}
                                                            disabled={solaLettura}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}